import { delay } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { RouterAction } from '@cbridge-packages/routing';
import { generateScheduleProfileIntervalRoute } from '@cbridge-packages/routing-client-admin';
import { ScheduleIntervalAction, scheduleIntervalListSelector } from '@cbridge-packages/schedule-interval';

type IState =
  & IGetSelectorStateType<typeof scheduleIntervalListSelector>;

export const toggleViewScheduleIntervalSidebarEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.update.done),
  delay(100),
  withLatestFrom(state$),
  map(([{ params }, state]) => {
    const { index, scheduleId } = params;
    const intervalIndex = index ?? scheduleIntervalListSelector(state, { scheduleId })?.length ?? 0;

    return RouterAction.replace([generateScheduleProfileIntervalRoute(scheduleId, intervalIndex)]);
  }),
);
